module.exports = __webpack_public_path__ + "img/11.58532f7.png";